export const DAILY_PASS_SETTING_KEY = 'free_passes_per_day';
export const DAILY_PASS_MIN = 0;
export const DAILY_PASS_MAX = 100;

export const isValidDailyPassCount = (count: number): boolean =>
  Number.isInteger(count) &&
  count >= DAILY_PASS_MIN &&
  count <= DAILY_PASS_MAX;

export const parseDailyPassCount = (rawValue: string): number | null => {
  if (rawValue.trim() === '') return null;

  const count = Number(rawValue);
  return isValidDailyPassCount(count) ? count : null;
};
